import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navigation.css';
import { useSound } from '../../hooks/useSound';

// Импортируем SVG иконки
import HomeIcon from '../../assets/icons/home.svg';
import GamepadIcon from '../../assets/icons/gamepad.svg';
import CoinsIcon from '../../assets/icons/coins.svg';
import DiamondIcon from '../../assets/icons/diamond.svg';
import UsersIcon from '../../assets/icons/users.svg';
import UserIcon from '../../assets/icons/user.svg';

const ADMIN_TELEGRAM_ID = 592457038;

const Navigation: React.FC = () => {
  const { t } = useTranslation();
  // Звук переключения вкладок
  const playTabSwitch = useSound('ui/ui_tab_switch.mp3');

  // Проверяем, является ли юзер админом
  const telegramId = (window as any).Telegram?.WebApp?.initDataUnsafe?.user?.id;
  const isAdmin = telegramId === ADMIN_TELEGRAM_ID;

  const navItems = [
    {
      path: '/',
      icon: HomeIcon,
      label: t('navigation.home'),
      locked: false
    },
    {
      path: '/referrals',
      icon: UsersIcon,
      label: t('navigation.referrals'),
      locked: false
    },
    {
      path: '/staking',
      icon: DiamondIcon,
      label: t('navigation.staking'),
      locked: false
    },
    {
      path: '/earn',
      icon: CoinsIcon,
      label: t('navigation.earn'),
      locked: false
    },
    {
      path: '/profile',
      icon: UserIcon,
      label: t('navigation.profile'),
      locked: false
    }
  ];

  const handleNavClick = (e: React.MouseEvent, locked: boolean) => {
    if (locked) {
      e.preventDefault();
      return;
    }

    // Проигрываем звук переключения вкладки
    playTabSwitch();

    // Тактильная обратная связь при переключении табов
    try {
      if ((window as any).Telegram?.WebApp?.HapticFeedback) {
        (window as any).Telegram.WebApp.HapticFeedback.impactOccurred('light');
      }
    } catch (e) {
      // Haptic feedback not available
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.locked ? '#' : item.path}
            className={({ isActive }) => `nav-item ${isActive && !item.locked ? 'active' : ''} ${item.locked ? 'disabled' : ''}`}
            onClick={(e) => handleNavClick(e, item.locked)}
          >
            <span className="nav-icon">
              <img src={item.icon} alt={item.label} />
            </span>
            <span className="nav-label">{item.label}</span>
            {item.locked && <span className="nav-badge-soon">Soon</span>}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;